/**
 * For expected values, see:
 * @see https://docs.mapbox.com/help/glossary/zoom-level/#zoom-levels-and-geographical-distance
 */
export const metersPerPixel = (latitude, zoomLevel) => {
  const earthCircumference = 40075017
  const latitudeRadians = latitude * (Math.PI / 180)
  return earthCircumference * Math.cos(latitudeRadians) / 2 ** (zoomLevel + 9)
}

/**
 * @param {{ lat, lng }} from
 * @param {{ lat, lng }} to
 */
export const metersBetween = (from, to) => {
  const r = 6371000 // m
  const p = Math.PI / 180

  const a = 0.5 - Math.cos((to.lat - from.lat) * p) / 2
                + Math.cos(from.lat * p) * Math.cos(to.lat * p) *
                  (1 - Math.cos((to.lng - from.lng) * p)) / 2

  return 2 * r * Math.asin(Math.sqrt(a))
}

/**
 * Does not take difference in meters/pixel the farther latitude is from the equator into the equation
 * Uses latitude from.lat to calculate meters/pixel
 * @param {{ lat, lng }} from coordinates
 * @param {{ lat, lng }} to coordinates
 * @param {Number} zoomLevel mapbox zoomlevel
 * @returns distance in screen pixels
 */
export const pixelsBetween = (from, to, zoomLevel) => {
  return metersBetween(from, to) / metersPerPixel(from.lat, zoomLevel)
}

/* !NOTE
 * Takes metersPerPixel at measured distance altitudes into equation, but for some reason metersBetween calculates wrong (it should differ at each step but always give the same measured distance).
 * The simpler function above works for all our current use cases so instead of going deeper we'll let this be here until we need to finish it, might not even be much work left

 * Heavily unoptimized and should not be executed frequently/used in a loop
 * @param {{ lat, lng }} from coordinates
 * @param {{ lat, lng }} to coordinates
 * @param {Number} zoomLevel mapbox zoomlevel
 * @param {Number} accuracy the higher the slower but the more exact result
 * @returns distance in screen pixels
export const pixelsBetween = (from, to, zoomLevel, accuracy = 10) => {
  const difference = {
    lat: Math.abs(from.lat - to.lat),
    lng: Math.abs(from.lng - to.lng)
  }

  const steps = Math.round(difference.lat) * accuracy

  const coordinatesStep = (step, coordinates) => Object.keys(coordinates)
    .reduce((coordinates, coordinate) => ({
      ...coordinates,
      [coordinate]: from[coordinate] + ((difference[coordinate] / steps) * step)
    }), {})

  let currentStep = 0
  let pixelsBetween = 0

  while (currentStep < steps) {
    const measureDistanceFrom = coordinatesStep(currentStep, from)
    const measureDistanceTo = coordinatesStep(currentStep + 1, to)
    pixelsBetween += metersBetween(measureDistanceFrom, measureDistanceTo) / metersPerPixel(measureDistanceFrom.lat, zoomLevel)
    currentStep += 1
  }

  return pixelsBetween
}
*/
